export function getOrderSurchargeTotal(order) {
  const fixedSurcharge = Math.max(0, Number(order?.surchargeAmount || 0));
  const subtotal = Math.max(0, Number(order?.subTotal || 0));
  const percentage = Math.max(0, Number(order?.totalDiscount || 0));
  const percentageSurcharge = subtotal * percentage / 100;

  return Number((fixedSurcharge + percentageSurcharge).toFixed(2));
}
